<template>
  <div class="recommended">
    <div class="recommended__header">
      <span class="recommended__title" v-stop-draggable>{{title}}</span>
      <span
        v-stop-draggable
        class="recommended__count"
        :class="`recommended__title_${countColor}`"
      >{{currentLength}}</span>
    </div>
    <div class="form-control recommended__text-area-wrapper" >
      <textarea
        :ref="type"
        v-stop-draggable
        rows="1"
        class="recommended__text-area"
        :placeholder="placeholder"
        v-model="modelValue"></textarea></div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import ContentElements from './ContentElements'

/**
   * Stylized input field. Used in {@link ContentElements}
   */
export default {
  name: 'RecommendedContent',
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    title: {
      type: String
    },
    maxLength: {
      type: Number
    },
    minLength: {
      type: Number
    },
    type: {
      type: String,
      required: true
    },
    placeholder: {
      type: String
    },
    // recommended brief content property bound to the component
    modelValue: {
      default: null
    },
    singleLine: {
      type: Boolean,
      default: false
    },
    orangeZone: {
      type: Number
    }
  },
  data () {
    return {}
  },
  watch: {
    modelValue: {
      handler (value) {
        this.$nextTick(this.onKeyUp)
        this.$emit('change', value)
      },
      immediate: true
    }
  },
  methods: {
    onKeyUp () {
      const element = this.$refs[this.type]
      if (element) {
        element.style.height = 'auto'
        element.style.height = element.scrollHeight + 'px'
      }
    }
  },
  computed: {
    currentLength () {
      return this.modelValue ? `${this.modelValue.length} of ${this.maxLength} characters` : ''
    },
    countColor () {
      return !this.modelValue
        ? ''
        : this.modelValue.length > this.orangeZone
          ? 'red'
          : this.modelValue.length <= this.maxLength
            ? 'green'
            : 'orange'
    }
  }
}
</script>

<style scoped lang="scss">

  .recommended {
    display: grid;
    grid-template-columns: auto  1fr;
    grid-template-rows: auto auto;
    grid-template-areas: 'title count' 'input  input';
    grid-gap: 10px;

    &__header {
      display: flex;
    }

    &__input {
      width: 100%;
      box-sizing: border-box;
      padding-right: 60px;
      @include ellipsis;
    }

    &__count {
      margin-left: 8px;
      white-space: nowrap;
      color: $rfx-silver;
      font-size: 14px;
      grid-area: count;
    }

    &__title {
      white-space: nowrap;
      display: block;
      color: $rfx-dark-march;
      font-weight: 500;
      grid-area: title;

      &_red {
        color: $rfx-red;
      }

      &_green {
        color: $rfx-green;
      }

      &_orange {
        color: $rfx-orange;
      }
    }

    &__text-area {
      width: 100%;
      padding: 0;
      font-size: 16px;
      resize: none;
      outline: none;
      border: none;
      grid-area: input;

      &::placeholder {
        color: $rfx-pearl;
        font-weight: normal;
        font-size: 14px;
        margin-top: -5px;
      }

      &-wrapper {
        flex: 1;
        padding: 10px 20px;
        height: auto;
        grid-area: input;
      }
    }
  }

  .form-control {
    padding: 20px;
    border: 1px solid $rfx-light-steel;
    outline: none;
    border-radius: 4px;
    color: $rfx-dark-march;
    font-size: 16px;

    &::placeholder {
      color: $rfx-pearl;
      font-weight: normal;
      font-size: 14px;
    }

    &:disabled {
      background-color: $rfx-light-steel;
    }

    &_error{
       border-color: $rfx-red;
      color: $rfx-red;

       &::placeholder {
         color: $rfx-red;
         font-size: 13px;
       }

     }
  }

</style>
